import logo from '@/assets/logo.svg';
import ESelectLanguage from '@/components/everridge/ESelectLanguage';
import AccountPopup from '@/features/account/components/AccountPopup';
import { FC } from 'react';
import { SidebarTrigger } from '@/components/ui/sidebar.tsx';
import { useLocation, useNavigate } from 'react-router-dom';
import SelectHotel from '@/features/hotels/components/SelectHotel';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';
import { cn } from '@/lib/utils';
import { useIsAuthenticated } from '@/features/identity/hooks/useIsAuthenticated.ts';
import { useUserRole } from '@/features/identity/hooks/useUserRole.ts';
import { Roles } from '@/@types/auth.types';
import NotificationsBar from '@/features/notifications/componentns/NotificationsBar';
import { useMultiCurrencyStorage } from '@/features/hotels/hooks/useHotelMultiCurrencyStorage';

type Props = { showSidebarTrigger?: boolean };

const EHeader: FC<Props> = ({ showSidebarTrigger = true }) => {
    const isAuthenticated = useIsAuthenticated();
    const userType = useUserRole();
    const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);
    const navigate = useNavigate();
    const location = useLocation();
    const isAuthRoute = location.pathname.startsWith('/auth');
	const { multiCurrency } = useMultiCurrencyStorage();

    return (
        <header
            className={cn(
                'py-4 bg-popover-10 border-b border-popover-100',
                isMobile ? 'px-4' : 'px-8',
            )}
        >
            <div className="flex items-center justify-between gap-2 ">
                {showSidebarTrigger && isAuthenticated && (
                    <SidebarTrigger className={'[&_svg]:size-5'} />
                )}
                <div className="flex gap-4">
                    {userType === Roles.admin && !isAuthRoute && (
                        <div
                            className={'flex items-center gap-2 select-none cursor-pointer mr-auto'}
                            onClick={() => navigate('/')}
                        >
                            <img src={logo} alt={'logo'} className={'size-6'} />
                            <h1
                                className={cn(
                                    isMobile && 'text-lg font-semibold text-popover-1000',
                                    !isMobile &&
                                        isAuthenticated &&
                                        'text-xl font-bold text-popover-10',
                                    !isMobile && 'text-xl font-bold text-popover-1000',
                                )}
                            >
                                OwnInn
                            </h1>
                        </div>
                    )}
                    {isAuthenticated && userType === Roles.owner && <SelectHotel />}
                </div>
                <div className={'flex gap-4'}>
                    {!isMobile && <ESelectLanguage showCurrency={isAuthenticated && !!userType && multiCurrency} />}
                    {userType === Roles.owner && !isMobile && <NotificationsBar />}
                    <AccountPopup />
                </div>
            </div>
        </header>
    );
};

export default EHeader;
